<template>
  <div style="width: 100%">
    <v-row>
      <v-col>
        <v-row>
          <v-col cols="12">
            <!-- tabela de experiências profissionais -->
            <v-data-table
              :headers="headersExperienciaProfissional"
              :items="experienciasProfissionais"
              class="elevation-0"
              item-key="id"
            >
              <!-- header -->
              <template v-slot:top>
                <v-subheader class="pl-0">
                  <v-row no-gutters>
                    <h2
                      class="
                        title
                        primary--text
                        text--darken-1 text-no-wrap
                        mt-0
                        ml-2
                      "
                    >
                      EXPERIÊNCIAS PROFISSIONAIS
                    </h2>
                  </v-row>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        absolute
                        color="primary"
                        dark
                        right
                        text
                        @click="openDialogCreateExperienciaProfissional()"
                        v-on="on"
                      >
                        Adicionar
                        <v-icon class="ml-2">
                          add_circle
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Clique para adicionar uma experiência profissional</span>
                  </v-tooltip>
                </v-subheader>
              </template>

              <!-- Setor -->
              <template v-slot:[`item.nomeCargo`]="{ item }">
                {{ item.nomeCargo }}
                <v-chip
                  v-if="item.fonte"
                  class="ml-2"
                  color="success"
                  outlined
                  x-small
                >
                  Importado
                </v-chip>
              </template>

              <!-- tempo de experiência -->
              <template v-slot:[`item.tempoExperiencia`]="{ item }">
                {{ getDescricaoTempo(getCargaHoraria(item)) }}
              </template>

              <!-- período -->
              <template v-slot:[`item.periodo`]="{ item }">
                {{ getDescricaoPeriodo(item) }}
              </template>

              <!-- ações -->
              <template v-slot:[`item.actions`]="{ item }">
                <!-- editar -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-if="!item.fonte"
                      class="mr-2"
                      color="secondary"
                      icon
                      small
                      @click="openDialogUpdateExperienciaProfissional(item)"
                      v-on="on"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Clique para editar a experiência profissional</span>
                </v-tooltip>

                <!-- deletar -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-if="!item.fonte"
                      color="error"
                      icon
                      small
                      @click="confirmDelete(item)"
                      v-on="on"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Clique para excluir a experiência profissional</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <!-- Áreas de atuação -->
        <v-row>
          <v-col cols="12">
            <areas-perfil-select
              :areas="perfil.areasProfissional"
              :lista="listaAreasProfissional"
              :maximo-areas="5"
              icone="business_center"
              tipo="ATUACAO"
              :mostrar-instrutor="false"
              @confirm="(value) => saveAreasAtuacao(value)"
              @return="(value) => saveAreasAtuacao(value)"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <dialog-experiencia-profissional
      :dialog-props="dialogs.dialogExperienciaProfissional"
    />

    <dialog-remove
      v-if="dialogs.dialogRemoveExperiencia.visibilidade"
      :confirm-action="deleteExperienciaProfissional"
      :dialog-visible="dialogs.dialogRemoveExperiencia.visibilidade"
      :toogle-visible="toogleDialogRemoveExperienciaProfissional"
      descricao="Você realmente deseja excluir essa experiência profissional?"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DialogRemove from '@/components/DialogRemove';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import AreasPerfilSelect from '@/components/perfil/AreasPerfilSelect';
import DialogExperienciaProfissional from '@/views/perfil/tabs/DialogExperienciaProfissional';
import Data from '@/modules/data';

const experienciaProfissionalRepository = RepositoryFactory.get('experienciaProfissional');

export default {
  name: 'AtuacaoProfissional',

  components: {
    DialogRemove,
    AreasPerfilSelect,
    DialogExperienciaProfissional,
  },

  props: {
    perfil: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      dialogs: {
        dialogExperienciaProfissional: {
          visibilidade: false,
          valid: false,
          acao: 'cadastrar',
          item: null,
        },
        dialogRemoveExperiencia: { visibilidade: false },
      },
    };
  },

  computed: {
    ...mapState({
      listaAreasProfissional: (state) => state.perfil.listaAreasProfissional,
    }),
    headersExperienciaProfissional() {
      return [
        {
          text: 'CARGO',
          value: 'nomeCargo',
          sortable: false,
          width: '10%',
          align: 'center',
        },
        {
          text: 'SETOR',
          value: 'nomeSetor',
          sortable: false,
          width: '10%',
          align: 'start',
        },
        {
          text: 'INSTITUIÇÃO',
          value: 'instituicao',
          sortable: false,
          width: '10%',
          align: 'start',
        },
        {
          text: 'VÍNCULO',
          value: 'nomeVinculo',
          sortable: false,
          width: '10%',
          align: 'start',
        },
        {
          text: 'FUNÇÃO GRATIFICADA',
          value: 'nomeFuncao',
          sortable: false,
          width: '10%',
          align: 'center',
        },
        {
          text: 'NÍVEL DE GRATIFICAÇÃO',
          value: 'nomeNivelGratificacao',
          sortable: false,
          width: '10%',
          align: 'center',
        },
        {
          text: 'SITUAÇÃO',
          value: 'status.descricao',
          sortable: false,
          width: '10%',
          align: 'center',
        },
        {
          text: 'PERÍODO',
          value: 'periodo',
          sortable: false,
          width: '10%',
          align: 'center',
        },
        {
          text: 'TEMPO DE EXPERIÊNCIA',
          value: 'tempoExperiencia',
          sortable: false,
          width: '10%',
          align: 'center',
        },
        {
          text: 'AÇÕES',
          value: 'actions',
          sortable: false,
          width: '10%',
          align: 'center',
        },
      ];
    },
    experienciasProfissionais() {
      return this.perfil.experienciasProfissionais.slice().sort((a, b) => a.inicio.localeCompare(b.inicio));
    },
  },

  methods: {
    saveAreasAtuacao(areas) {
      if (areas.length <= 5) {
        this.perfil.areasProfissional = areas;

        this.$emit('updatePerfil', this.perfil);
      } else {
        this.$store.dispatch('app/error', {
          message: 'É necessário remover áreas de atuação até o limite de 5 itens.',
        });
      }
    },
    confirmDelete(item) {
      this.dialogs.dialogRemoveExperiencia.item = item;
      this.toogleDialogRemoveExperienciaProfissional();
    },
    deleteExperienciaProfissional() {
      const experienciaId = this.dialogs.dialogRemoveExperiencia.item.id;
      experienciaProfissionalRepository.delete(experienciaId).then((res) => {
        const index = this.perfil.experienciasProfissionais.findIndex((e) => e.id === experienciaId);
        this.perfil.experienciasProfissionais.splice(index, 1);

        this.toogleDialogRemoveExperienciaProfissional();

        this.$store.dispatch('app/success', {
          response: res,
          message: 'Experiência profissional excluída com sucesso!',
        });
      });
    },
    openDialogCreateExperienciaProfissional() {
      this.dialogs.dialogExperienciaProfissional.item = null;
      this.dialogs.dialogExperienciaProfissional.acao = 'cadastrar';
      this.dialogs.dialogExperienciaProfissional.visibilidade = true;
    },
    openDialogUpdateExperienciaProfissional(item) {
      this.dialogs.dialogExperienciaProfissional.experienciaProfissional = item;
      this.dialogs.dialogExperienciaProfissional.acao = 'editar';
      this.dialogs.dialogExperienciaProfissional.visibilidade = true;
    },
    toogleDialogRemoveExperienciaProfissional() {
      this.dialogs.dialogRemoveExperiencia.visibilidade = !this.dialogs.dialogRemoveExperiencia.visibilidade;
    },
    getCargaHoraria(item) {
      return this.getMonths(item).length;
    },
    getMonths(item) {
      const inicio = Data.create(item.inicio);
      const termino = Data.create(item.status.id === 'ATUAL' ? Data.get('YYYY-MM-DD') : item.termino);
      const currentMonth = inicio.clone();
      const months = [];

      while (currentMonth.isSameOrBefore(termino)) {
        months.push(currentMonth.format('MM/YYYY'));
        currentMonth.add(1, 'months');
      }
      return months;
    },
    getDescricaoPeriodo(item) {
      if (item && item.id) {
        let descricao = '';
        if (item.status && item.status.id === 'ATUAL') {
          descricao += `De ${Data.format(item.inicio, 'MM/YYYY')} até hoje`;
        } else {
          descricao += `De ${Data.format(item.inicio, 'MM/YYYY')} até ${Data.format(item.termino, 'MM/YYYY')}`;
        }
        return descricao;
      }
      return '';
    },
    getDescricaoTempo(meses) {
      if (meses < 12) {
        let descricao = '';

        if (meses === 0) {
          descricao += '0';
        } else if (meses === 1) {
          descricao += `${meses} mês`;
        } else {
          descricao += `${meses} meses`;
        }

        return descricao;
      }
      const anos = parseInt(meses / 12, 10);
      meses -= anos * 12;
      let descricao = anos;

      if (anos === 1) {
        descricao += ' ano';
      } else {
        descricao += ' anos';
      }

      if (meses === 0) {
        descricao += '';
      } else if (meses === 1) {
        descricao += ` e  ${meses} mês`;
      } else {
        descricao += ` e  ${meses} meses`;
      }

      return descricao;
    },
  },
};
</script>
